var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClicked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2002 10C17.5752 10 19.5752 11.625 20.0752 13.875C20.2002 14.5 20.9502 15 21.5752 14.75C22.2002 14.625 22.7002 13.875 22.4502 13.25C21.7002 9.75 18.7002 7.5 15.2002 7.5C11.0752 7.5 7.7002 10.875 7.7002 15C7.7002 18.875 10.7002 22.125 14.5752 22.5H14.7002C15.3252 22.5 15.8252 22 15.9502 21.375C16.0752 20.75 15.4502 20.125 14.8252 20C12.3252 19.75 10.2002 17.5 10.2002 15C10.2002 12.25 12.4502 10 15.2002 10Z",
    fill: "#6366F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2002 25C9.7002 25 5.2002 20.5 5.2002 15C5.2002 9.5 9.7002 5 15.2002 5C20.4502 5 24.8252 9.125 25.2002 14.375C25.2002 15.125 25.8252 15.625 26.5752 15.5C27.3252 15.5 27.8252 14.875 27.7002 14.125C27.2002 7.625 21.8252 2.5 15.2002 2.5C8.3252 2.5 2.7002 8.125 2.7002 15C2.7002 21.875 8.3252 27.5 15.2002 27.5C15.9502 27.5 16.4502 27 16.4502 26.25C16.4502 25.5 15.9502 25 15.2002 25Z",
    fill: "#6366F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8242 18.1251C26.6992 18.0001 26.4492 17.8751 26.3242 17.8751L18.1992 15.1251C17.4492 14.8751 16.5742 15.1251 15.9492 15.7501C15.3242 16.3751 15.1992 17.2501 15.5742 18.0001L19.3242 26.2501C19.6992 27.0001 20.4492 27.5001 21.1992 27.5001H21.5742C22.5742 27.3751 23.1992 26.6251 23.3242 25.6251L23.6992 22.6251L26.1992 21.8751C26.9492 21.6251 27.5742 21.0001 27.6992 20.1251C27.8242 19.3751 27.4492 18.5001 26.8242 18.1251ZM22.8242 20.2501C21.9492 20.5001 21.4492 21.1251 21.3242 22.0001L21.0742 23.8751L18.3242 17.7501L24.3242 19.7501L22.8242 20.2501Z",
    fill: "#6366F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClicked);
export default __webpack_public_path__ + "static/media/clicked.74cd996f9b8fce6684fb40a6cf9475bf.svg";
export { ForwardRef as ReactComponent };